import React, { Fragment } from 'react';
import { AutoComplete, Button, DatePicker, Form, Input, Modal, notification, Select, Typography } from "antd";
import ApiService from "../../../services/ApiService"
import moment from "moment";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const { Search } = Input;
const { Text } = Typography;
const { Option } = Select;

export default class ModalAddCom extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        contact: null,
        id: null,
        edit: false,
        defaultData: {},
        actions: [],
        types: [],
        selectedActions: [],
        title: t`une Activité`
    };

    state = this.initialState;

    async show(contactId, data = {}) {
        await Promise.all([this.init(), this.getTypes()])

        if (data.id) {
            let ndata = { ...data }
            ndata.datetime = moment(ndata.datetime)
            this.setState({
                visible: true,
                edit: true,
                contact: contactId,
                id: data.id,
                selectedActions: (ndata.actions || []),
                defaultData: ndata
            })
        } else {
            this.setState({ visible: true, contact: contactId, defaultData: { datetime: moment(new Date()) } })
        }
    }

    async addVisite(contactId, adresse) {
        await this.init()
        const _defaultData = {
            datetime: moment(new Date()),
            type: t`Visite`,
            adresse: adresse
        }
        this.setState({ visible: true, contact: contactId, defaultData: _defaultData, title: t`une Visite` })
    }

    async addAppel(contactId) {
        await this.init()
        const _defaultData = {
            datetime: moment(new Date()),
            type: t`Appel`
        }
        this.setState({ visible: true, contact: contactId, defaultData: _defaultData, title: t`un Appel` })
    }

    close() {
        this.setState(this.initialState)
    }

    async init() {
        const DEFAULT=[`Tefiline`,`Neshek`,t`Discussion`]

        var res = await ApiService.get("/contact/commentaire/actions")
        if (res.success) {
            this.setState({ actions: [...new Set(DEFAULT.concat(res.items).sort())] })
        }
    }

    async getTypes() {
        const DEFAULT=[t`Visite`,t`Rencontre`,t`Rendez-vous`,t`Appel`,t`Autre`]

        var res = await ApiService.get("/contact/commentaire/types")
        if (res.success) {
            this.setState({ types: [...new Set(DEFAULT.concat(res.items).sort())] })
        }
    }

    async onSubmit(data) {
        data.datetime = data.datetime.toDate()
        data.actions = this.state.selectedActions

        if (this.state.id) {
            data.id = this.state.id
        }

        let contactId = this.state.contact
        if (contactId?.id) {
            contactId = contactId.id
        }

        this.setState({ loading: true })

        var res = await ApiService.post("/contact/commentaire/edit/" + contactId, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Succès de la modification` : t`Succès de l'ajout`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish(data)
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de la modification` : t`Erreur lors de l'ajout`
            })
        }

        this.setState({ loading: false })
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.id ? t`Éditer ${this.state.title}` : t`Ajouter ${this.state.title}`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >

                <Form
                    onFinish={(data) => this.onSubmit(data)}
                    ref={(ref) => this.form = ref}
                    layout={"vertical"}
                    initialValues={this.state.defaultData}
                >
                    <Form.Item shouldUpdate>
                        {(form) => {
                            return (
                                <Fragment>
                                    <Form.Item
                                        label={<Trans>Type</Trans>}
                                        name="type"
                                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                                    >
                                        <AutoComplete placeholder={t`Type d'activité`}>
                                            {this.state.types.map(i => (
                                                <AutoComplete.Option value={i}>{i}</AutoComplete.Option>
                                            ))}
                                        </AutoComplete>
                                    </Form.Item>

                                    {form.getFieldValue("type") === t`Visite` && (
                                        <Form.Item
                                            label={<Trans>Adresse complète</Trans>}
                                            name="adresse"
                                        >
                                            <Input placeholder={t`Adresse complète`} />
                                        </Form.Item>
                                    )}

                                    <Form.Item label={<Trans>Actions</Trans>}>
                                        <Select
                                            mode="tags"
                                            placeholder={t`Actions`}
                                            value={this.state.selectedActions}
                                            onSelect={(value) => {
                                                var newArray = [...this.state.selectedActions]
                                                newArray.push(value)
                                                this.setState({ selectedActions: newArray })
                                            }}
                                            onDeselect={(value) => {
                                                var newArray = [...this.state.selectedActions]
                                                newArray.splice(newArray.indexOf(value), 1)
                                                this.setState({ selectedActions: newArray })
                                            }}
                                        >
                                            {this.state.actions.filter(i => !this.state.selectedActions.includes(i)).map((item, index) =>
                                                <Select.Option key={index} value={item}>{item}</Select.Option>
                                            )}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label={<Trans>Commentaire</Trans>}
                                        name="content"
                                    >
                                        <Input.TextArea placeholder={t`Votre commentaire`} />
                                    </Form.Item>

                                    <Form.Item
                                        label={<Trans>Date & Heure</Trans>}
                                        name="datetime"
                                        rules={[{ required: true, message: t`Ce champ est obligatoire` }]}
                                    >
                                        <DatePicker format={"DD/MM/YYYY à HH:mm"} showTime placeholder={t`Date & Heure`} />
                                    </Form.Item>
                                </Fragment>
                            )
                        }}
                    </Form.Item>

                    <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>
                            <Trans>Valider</Trans>
                        </Button>
                    </Form.Item>
                </Form>

            </Modal>
        )
    }
}
